import { COLORS } from '../../../../../constants/colors';

export const useStyles = () => ({
  videoContainer: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: COLORS.DARK_GREY,
    overflow: 'hidden',
    cursor: 'pointer',
  },
  avatar: {
    backgroundColor: COLORS.DARK_GREY,
    borderRadius: '50%',
    width: 56,
    height: 56,
    cursor: 'pointer',
  },
});
